<template>
  <Button
    fsize="f14"
    variant="main"
    class="l-w-230"
    :class="{ 'is-loading': isLoading }"
    :disabled="isDisabled"
    @click="click"
  >
    <span>ダウンロード</span>
  </Button>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Button
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>
